import { render, staticRenderFns } from "./MobileDownloadLinkButtons.vue?vue&type=template&id=60a5dd5e"
import script from "./MobileDownloadLinkButtons.vue?vue&type=script&lang=js"
export * from "./MobileDownloadLinkButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports